var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden","width":"100%"}},[(!_vm.mobileListener)?_c('div',{attrs:{"id":"select-to-sort-text"}},[_vm._v("↓ Select a row to sort by a bacterium")]):_vm._e(),_c('div',{class:_vm.constrainedView ? '' : 'scrolls',attrs:{"id":"bubble-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }